import { render, staticRenderFns } from "./owner_onboarding.vue?vue&type=template&id=a8cf52b6&scoped=true"
import script from "./owner_onboarding.vue?vue&type=script&lang=js"
export * from "./owner_onboarding.vue?vue&type=script&lang=js"
import style0 from "./owner_onboarding.vue?vue&type=style&index=0&id=a8cf52b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8cf52b6",
  null
  
)

export default component.exports